/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var FetchFromNotionRequest;
(function (FetchFromNotionRequest) {
    var PageToFeetch;
    (function (PageToFeetch) {
        PageToFeetch["NOTION_PAGE_OFFERS"] = "NOTION_PAGE_OFFERS";
        PageToFeetch["NOTION_PAGE_FUNNLES"] = "NOTION_PAGE_FUNNLES";
        PageToFeetch["NOTION_PAGE_PRODUCTS"] = "NOTION_PAGE_PRODUCTS";
        PageToFeetch["NOTION_PAGE_STIKYBARS"] = "NOTION_PAGE_STIKYBARS";
        PageToFeetch["NOTION_PAGE_COURSES"] = "NOTION_PAGE_COURSES";
        PageToFeetch["NOTION_PAGE_COURSE_CATEGORIES"] = "NOTION_PAGE_COURSE_CATEGORIES";
        PageToFeetch["NOTION_PAGE_FILINGCARDS"] = "NOTION_PAGE_FILINGCARDS";
        PageToFeetch["NOTION_PAGE_DEDUCTIONS"] = "NOTION_PAGE_DEDUCTIONS";
        PageToFeetch["NOTION_PAGE_RESOURCE_VAULT"] = "NOTION_PAGE_RESOURCE_VAULT";
        PageToFeetch["NOTION_PAGE_ALL"] = "NOTION_PAGE_ALL";
    })(PageToFeetch = FetchFromNotionRequest.PageToFeetch || (FetchFromNotionRequest.PageToFeetch = {}));
})(FetchFromNotionRequest || (FetchFromNotionRequest = {}));
//# sourceMappingURL=FetchFromNotionRequest.js.map